module.exports = __webpack_public_path__ + "img/phyton.07bb6fa4.png";